const CheckboxChecked = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none">
    <path
      className="fill-field-checked-radio stroke-field-checked-radio"
      d="M.5 4A3.5 3.5 0 0 1 4 .5h16A3.5 3.5 0 0 1 23.5 4v16a3.5 3.5 0 0 1-3.5 3.5H4A3.5 3.5 0 0 1 .5 20V4Z"
    />
    <path
      fill="var(--checkbox-checked-fill)"
      d="m10.126 17.407-.026.026-5.1-5.1 2.149-2.148 2.977 2.977 7.161-7.161 2.15 2.149-9.284 9.284-.027-.027Z"
    />
  </svg>
)
export { CheckboxChecked }
